import { COLORS } from '@shared/styles/constants';
import { OverrideToken } from 'antd/es/theme/interface';

export const buttonConfig: OverrideToken['Button'] = {
    fontWeight: 600,
    controlHeightLG: 64,
    paddingInlineLG: 32,

    colorBgContainerDisabled: COLORS.grey300,
    lineHeight: 1.5,

    controlHeight: 56,
    paddingInline: 32,

    controlHeightSM: 40,
    paddingInlineSM: 12,

    fontSizeSM: 14,

    defaultColor: COLORS.dark,
    defaultBg: COLORS.grey100,
    defaultBorderColor: 'transparent',
    defaultHoverColor: COLORS.primary,
    defaultHoverBorderColor: 'transparent',
    defaultActiveColor: COLORS.primary,
    defaultActiveBg: COLORS.grey100,
    defaultActiveBorderColor: 'transparent',
    defaultBgDisabled: COLORS.grey300,
    colorBorderDisabled: 'transparent',
};
